import { IDonor } from '@nkr/models/donor';
import { IRecipient } from '@nkr/models/recipient';
import * as React from 'react';
import { Modal, Button, Radio, Checkbox, Label } from 'react-bootstrap';
import { SsdTableWrapper } from './styles';
import { useState } from 'react';

interface IProps {
    show: boolean,
    swapIndex: number,
    chainIndex: number,
    recipient: IRecipient,
    donors: IDonor[],
    onCancel: () => void,
    onConfirm: (swapIndex: number, chainIndex: number, bridgeDonorId: number) => void
}

const MultipleBridgeDonorsModal = (props: IProps) => {
    const { show, swapIndex, chainIndex, recipient, donors } = props;

    const [donorId, setDonorId] = useState(0);

    const handleConfirm = () => {
        let id = donorId;
        setDonorId(0);
        props.onConfirm(swapIndex, chainIndex, id)
    }

    const handleCancel = () => {
        setDonorId(0);
        props.onCancel();
    }

    const getWhichKidney = (donor: IDonor) => {
        if (donor.whichKidney != '' && donor.whichKidney != 'DNK') {
            let results = `${donor.whichKidneyAbbreviated}${donor.numberOfArteries}`;

            if (donor.whichKidney == 'L-opt') {
                results += '(R)';
            }

            if (donor.whichKidney == 'R-opt') {
                results += '(L)';
            }

            return results;
        }

        return '--';
    };

    if (!recipient) {
        return <></>
    }

    return (
        <Modal show={show} onHide={() => null}>
            <Modal.Header style={{ borderBottom: '0 none', display: 'grid' }}>
                <Label bsStyle='primary' style={{ fontSize: 'large', marginRight: '7.8vw', marginLeft: '7.8vw' }}>
                    Make Match Offer
                </Label>
                <h5 style={{ marginBottom: 0 }}>
                    Please select which intended donor you would like to include in this match.
                </h5>
            </Modal.Header>
            <Modal.Body>
                <div className='text-center h5'>
                    <SsdTableWrapper condensed striped bordered>
                        <thead>
                            <tr>
                                <th>Select</th>
                                <th>Bridge Donor</th>
                                <th>ABO</th>
                                <th>Age</th>
                                <th>FAnat</th>
                                <th>Wt</th>
                            </tr>
                        </thead>
                        <tbody>
                            {donors.length > 0 &&
                                donors
                                    .sort((x, y) => y.bloodTypeDisplay.localeCompare(x.bloodTypeDisplay))
                                    .map(x =>
                                        <tr>
                                            <td>
                                                <Checkbox style={{ display: 'inline' }} name={`donor-${x.alias}-checkBox`} inline checked={donorId == x.id} onClick={(e: React.MouseEvent<Radio & HTMLInputElement>) => setDonorId(x.id)} />
                                            </td>
                                            <td>{x.alias}</td>
                                            <td>{x.bloodTypeDisplay}</td>
                                            <td>{x.age}</td>
                                            <td>{getWhichKidney(x)}</td>
                                            <td>{x.weight}</td>
                                        </tr>
                                    )}
                        </tbody>
                    </SsdTableWrapper>
                </div>
            </Modal.Body>
            <Modal.Footer style={{ borderTop: '0 none' }}>
                <Button onClick={handleCancel}>Cancel</Button>
                <Button bsStyle='success' disabled={donorId <= 0} onClick={handleConfirm}>Make Match Offer</Button>
            </Modal.Footer>
        </Modal>
    );
}

export default MultipleBridgeDonorsModal;